import { createElement, type FC, type ReactNode } from 'react'

const icon = (children: ReactNode): FC<{ className?: string }> => ({ className }) =>
  createElement(
    'svg',
    {
      className,
      viewBox: '0 0 24 24',
      width: 24,
      height: 24,
      overflow: 'visible',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: 1.8,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    children,
  )

const path = (d: string, key?: string | number) => createElement('path', { d, key })
const circle = (cx: number, cy: number, r: number, key?: string | number) =>
  createElement('circle', { cx, cy, r, key })
const rect = (x: number, y: number, width: number, height: number, rx: number, key?: string | number) =>
  createElement('rect', { x, y, width, height, rx, key })

export const NewIcon = icon(path('M12 5v14M5 12h14'))
export const SearchIcon = icon([circle(11, 11, 6, 0), path('m16 16 4 4', 1)])
export const AiMagicIcon = icon([
  path('m12 3 1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z', 0),
  path('m18 16 .8 2.2L21 19l-2.2.8L18 22l-.8-2.2L15 19l2.2-.8z', 1),
])
export const HomeIcon = icon([path('m4 11 8-7 8 7', 0), path('M6 10v9h12v-9', 1)])
export const CenterDot = icon(circle(12, 12, 3))
export const MoreIcon = icon([circle(6, 12, 1.8, 0), circle(12, 12, 1.8, 1), circle(18, 12, 1.8, 2)])
export const BackIcon = icon(path('m15 18-6-6 6-6'))

export const RenameIcon = icon([
  path('m4 20 4.2-1 10-10-3.2-3.2-10 10z', 0),
  path('m13.8 6.2 3.2 3.2', 1),
])
export const ReprioritizeIcon = icon(path('M8 4v16M4 8l4-4 4 4M16 20V4m-4 12 4 4 4-4'))
export const LinkIcon = icon([
  path('M10 13a4 4 0 0 0 5.7.1l2-2a4 4 0 0 0-5.7-5.7l-1.1 1.1', 0),
  path('M14 11a4 4 0 0 0-5.7-.1l-2 2a4 4 0 0 0 5.7 5.7l1.1-1.1', 1),
])
export const DeleteIcon = icon(path('M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5'))
export const ShowConnectionsIcon = icon([
  circle(12, 12, 2, 0),
  circle(5, 6, 1.5, 1),
  circle(19, 6, 1.5, 2),
  circle(5, 18, 1.5, 3),
  path('m10.5 10.5-4.2-3M13.5 10.5l4.2-3M10.5 13.5l-4.2 3', 4),
])
export const CompleteIcon = icon([circle(12, 12, 8, 0), path('m8.5 12 2.2 2.2 4.8-5', 1)])
export const DuplicateIcon = icon([
  rect(8, 8, 11, 11, 1, 0),
  path('M5 16H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1', 1),
])
export const MoveToIcon = icon([
  path('M3 7h7l2 2h9v10H3z', 0),
  path('m11 14 3-3 3 3M14 11v7', 1),
])
export const EditIcon = RenameIcon
export const ShiftIcon = icon(path('M4 12h16M7 8l-4 4 4 4M17 8l4 4-4 4'))
export const ShowDependenciesIcon = ShowConnectionsIcon
export const NewGoalIcon = icon([circle(12, 12, 8, 0), path('M12 8v8M8 12h8M17 5l2 2', 1)])
export const NewTaskIcon = icon([circle(12, 12, 8, 0), path('M12 8v8M8 12h8M15 5h4', 1)])
export const NewGateIcon = icon([circle(12, 12, 8, 0), path('M8 12h8M12 8v8M16 5h3', 1)])
export const RealignIcon = icon(path('M5 5h14M5 12h14M5 19h14M9 3v18'))
export const ToggleDoneIcon = CompleteIcon
export const AddChildIcon = icon(path('M6 4v12h5M11 16l3-3M11 16l3 3M17 8v8M13 12h8'))
export const ShowBlockersIcon = ShowConnectionsIcon
export const ToggleAndOrIcon = icon([
  path('M5 16c2-6 4-8 6-8s4 2 6 8M15 8h4M17 6v4', 0),
  path('M5 19h7', 1),
])
export const AddInputIcon = icon([rect(5, 6, 9, 12, 1, 0), path('M18 9v8M14 13h8', 1)])
export const ShowInputsIcon = icon([rect(12, 7, 7, 10, 1, 0), path('m4 8 5 4M4 16l5-4', 1)])
export const ExportIcon = icon(path('M5 10v9h14v-9M12 4v10M8 8l4-4 4 4'))
export const SortIcon = icon(path('M5 6h14M5 12h10M5 18h6'))
export const MoveIcon = icon(path('M12 3v18M3 12h18M9 6 12 3l3 3M9 18l3 3 3-3M6 9 3 12l3 3M18 9l3 3-3 3'))

export { AddFieldIcon, AddSectionIcon, AssignIcon, ChangeRoleIcon, ChangeTypeIcon, CollapseIcon, ConvertToTaskIcon, CycleRoleIcon, DetachIcon, NewNodeIcon, OpenIcon, PingIcon, PreviewIcon, RemoveIcon, RequiredIcon, RescheduleIcon, ReflowIcon, SetRulesIcon } from './phase4Icons'
export const ShowDownstreamIcon = ShowConnectionsIcon
export const ShowAllBindingsIcon = ShowConnectionsIcon
export * from './phase5Icons'
